import { apiClient } from "./client";

export type UserBackup = {
  id: string;
  primary_user_id: string;
  primary_email: string | null;
  backup_user_id: string;
  backup_email: string | null;
  starts_at: string;
  ends_at: string;
  reason: string | null;
  created_at: string;
  active: boolean;
};

export type UserBackupCreatePayload = {
  backup_user_id: string;
  starts_at: string;
  ends_at: string;
  reason?: string | null;
};

export async function listMyBackups(): Promise<UserBackup[]> {
  const { data } = await apiClient.get<UserBackup[]>(
    "/api/v1/me/coordinator-backups",
  );
  return data;
}

export async function createMyBackup(
  p: UserBackupCreatePayload,
): Promise<UserBackup> {
  const { data } = await apiClient.post<UserBackup>(
    "/api/v1/me/coordinator-backups",
    p,
  );
  return data;
}

export async function deleteMyBackup(id: string): Promise<void> {
  await apiClient.delete(`/api/v1/me/coordinator-backups/${id}`);
}

export async function listAllBackups(activeOnly = false): Promise<UserBackup[]> {
  const { data } = await apiClient.get<UserBackup[]>(
    "/api/v1/admin/coordinator-backups",
    { params: { active_only: activeOnly } },
  );
  return data;
}
